import { render, staticRenderFns } from "./HorseForm.vue?vue&type=template&id=03ac2704&"
import script from "./HorseForm.vue?vue&type=script&lang=js&"
export * from "./HorseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports